import { gql } from '@apollo/client';
import {
  PLAYER_INFO_FRAGMENT,
  PLAYER_SEASON_STAT_FRAGMENT,
  SCHEDULE_FRAGMENT,
} from '../../fragments';

export const GET_HOMEPAGE_DATA = gql`
  ${PLAYER_INFO_FRAGMENT}
  ${PLAYER_SEASON_STAT_FRAGMENT}
  ${SCHEDULE_FRAGMENT}
  query ($date: date, $seasonId: Int!, $seasonsArr: [Int!], $gameLimit: Int) {
    seasons(where: { id: { _in: $seasonsArr } }) {
      id
      league
      season
      year
      teams(where: { champion: { _eq: true } }) {
        name
        id
      }
    }
    schedule(
      where: { date: { _gte: $date }, seasonId: { _eq: $seasonId } }
      limit: $gameLimit
      order_by: { date: asc, time: asc }
    ) {
      ...ScheduleFragment
      goalieAttendance: attendance(
        where: {
          _or: [
            { player: { positionSecondary: { _eq: GOALIE } } }
            { player: { position: { _eq: GOALIE } } }
          ]
        }
      ) {
        teamId
        player {
          id
          firstName
          lastName
          jersey
          jerseySecondary
          rosters {
            team {
              id
              name
            }
          }
        }
      }
    }
    teams(where: { seasonBySeason: { id: { _eq: $seasonId } } }) {
      id
      abbreviation
      color
      colorSecondary
      name
      rosters {
        players {
          ...PlayerInfo
          ...PlayerSeasonStats
        }
      }
    }
  }
`;
